import LOGO_WHITE from "@assets/TablaLogo.svg";
import { ReactElement } from "react";

export default function QnFooter(): ReactElement {
  return (
    <div className="hidden md:flex fixed bottom-4 left-8 z-40 items-center gap-2 text-neutral-300">
      <img className="block w-[145px]" alt="Home" src={LOGO_WHITE} />
    </div>
  );
}
